import { __assign, __rest } from "tslib";
import React, { useEffect, useRef, useImperativeHandle } from "react";
import classNames from "classnames";
import { useConfig } from "../util";
import { useDefaultValue } from "../form";
import { useIsomorphicLayoutEffect } from "../_util/use-isomorphic-layout-effect";
export var MonacoDiffEditor = React.forwardRef(function MonacoEditor(_a, ref) {
    var monaco = _a.monaco, original = _a.original, _b = _a.options, options = _b === void 0 ? {} : _b, language = _a.language, className = _a.className, style = _a.style, width = _a.width, height = _a.height, props = __rest(_a, ["monaco", "original", "options", "language", "className", "style", "width", "height"]);
    var classPrefix = useConfig().classPrefix;
    var _c = useDefaultValue(props, ""), value = _c.value, onChange = _c.onChange;
    var containerRef = useRef(null);
    var editorRef = useRef(null);
    var changeEventRef = useRef(null);
    // https://github.com/react-monaco-editor/react-monaco-editor/blob/master/src/editor.js
    var preventTriggerChangeEvent = useRef(false);
    useEffect(function () {
        if (editorRef.current) {
            editorRef.current.layout();
        }
    }, [width, height]);
    useEffect(function () {
        if (editorRef.current) {
            var originalModel = editorRef.current.getModel().original;
            originalModel.setValue(original);
        }
    }, [original, monaco]);
    useEffect(function () {
        if (editorRef.current) {
            var _a = editorRef.current.getModel(), modifiedModel = _a.modified, originalModel = _a.original;
            monaco.editor.setModelLanguage(modifiedModel, language);
            monaco.editor.setModelLanguage(originalModel, language);
        }
    }, [language, monaco]);
    useEffect(function () {
        if (editorRef.current) {
            var editor = editorRef.current;
            var modifiedModel = editor.getModel().modified;
            if (value != null && value !== modifiedModel.getValue()) {
                preventTriggerChangeEvent.current = true;
                editor.getModifiedEditor().pushUndoStop();
                modifiedModel.pushEditOperations([], [
                    {
                        range: modifiedModel.getFullModelRange(),
                        text: value,
                    },
                ], undefined);
                editor.getModifiedEditor().pushUndoStop();
                preventTriggerChangeEvent.current = false;
            }
        }
    }, [value, monaco]);
    useIsomorphicLayoutEffect(function () {
        var editor = monaco.editor.createDiffEditor(containerRef.current, __assign({}, options));
        editorRef.current = editor;
        var originalModel = monaco.editor.createModel(original, language);
        var modifiedModel = monaco.editor.createModel(value, language);
        editor.setModel({
            original: originalModel,
            modified: modifiedModel,
        });
        changeEventRef.current = modifiedModel.onDidChangeContent(function (event) {
            if (!preventTriggerChangeEvent.current) {
                onChange(modifiedModel.getValue(), { event: event });
            }
        });
        return function () {
            editorRef.current.dispose();
            originalModel.dispose();
            modifiedModel.dispose();
            if (changeEventRef.current) {
                changeEventRef.current.dispose();
            }
        };
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    useImperativeHandle(ref, function () { return ({
        editor: editorRef.current,
    }); });
    return (React.createElement("div", { className: classNames(classPrefix + "-monaco-editor-container", className), style: __assign(__assign({}, (style || {})), { height: height || "100%", width: width || "100%" }), ref: containerRef }));
});
MonacoDiffEditor.displayName = "MonacoDiffEditor";
//# sourceMappingURL=MonacoDiffEditor.js.map